// @flow

import React from "react";
import { localize } from "redux-i18n";
import { IconButton as ActionButton, Input, Row, Col } from "@components";
import { FlaggableHierarchyTree } from "@components";
import closeIconImg from "../../images/icon-close.svg";
import "./report-areas.style.scss";

type OwnProps = $Exact<{
  editable: boolean,
  selected: { id: number }[],
  excluded: { id: number }[],
  onTreeUpdate: () => void,
  removeItem: (from: string, id: number) => void,
  organizationStructure: Object,
}>;

type Props = PropsFromLocalize & OwnProps;

export const AreaOfAccessHierarchyTree = (props: Props) => {
  const selectedItems = props.organizationStructure.children.filter(item =>
    props.selected.some(({ id }) => item.data.id === id),
  );

  const excludedItems = selectedItems
    .reduce((target, item) => target.concat(item.children), [])
    .filter(item => props.excluded.some(({ id }) => item.data.id === id));

  return (
    <div className="d-flex report-areas w-100">
      <div className="col-4 pl-4 pr-3">
        <div className="area-title">{props.t("SELECT_AREAS")}</div>
        {props.editable && <Input placeholder={props.t("FIND_DEPARTMENT")} />}
        <FlaggableHierarchyTree
          className="company-tree checkbox-override"
          tree={props.organizationStructure}
          excluded={props.excluded}
          selected={props.selected}
          onChange={props.onTreeUpdate}
          indentSize={20}
          readOnly={!props.editable}
        />
      </div>
      <div className="col-8 pr-0 pl-3">
        <div className="area-block">
          <div className="area-title pl-2">{props.t("AREAS_INCLUDED")}</div>
          <Row className="text-grey pb-2 ml-0">
            <Col xs={5} className="pl-2">
              {props.t("UNIT_NAME")}
            </Col>
            <Col xs={3}>{props.t("DATE_ADDED")}</Col>
          </Row>
          {selectedItems.map(selected => (
            <Row className="area-line" data-id={selected.data.id} key={selected.data.id}>
              <Col xs={5}>{selected.data.label}</Col>
              <Col xs={3}>
                <Input name="dateAdded" className="w-100 float-right" type="date" />
              </Col>
              <Col xs={4} className="d-flex justify-content-end">
                {props.editable && (
                  <ActionButton
                    onClick={props.removeItem("selected", selected.data.id)}
                    icon={closeIconImg}
                  />
                )}
              </Col>
            </Row>
          ))}
        </div>
        <div className="area-block">
          <div className="area-title pl-2">{props.t("AREAS_EXCLUDED")}</div>
          <Row className="text-grey pb-2 ml-0">
            <Col xs={7} className="pl-2">
              {props.t("UNIT_NAME")}
            </Col>
            <Col xs={3}>{props.t("DATE_EXCLUDED")}</Col>
          </Row>
          {excludedItems.map(item => (
            <Row className="area-line" data-id={item.data.id} key={item.data.id}>
              <Col xs={7}>{item.data.label}</Col>
              <Col xs={3}>
                <Input name="startDate" className="w-100 float-right" type="date" />
              </Col>
              <Col xs={2} className="d-flex justify-content-end">
                {props.editable && (
                  <ActionButton
                    onClick={props.removeItem("excluded", item.data.id)}
                    icon={closeIconImg}
                  />
                )}
              </Col>
            </Row>
          ))}
        </div>
      </div>
    </div>
  );
};

export default localize()(AreaOfAccessHierarchyTree);
